export default {
    topNav: {
        size: 'Size',
        language: 'Language',
        refreshCache: 'Refresh Cache {{org}}',
    },
    topTicker: {
        ar: 'AR',
        val: 'VAL',
        rj: 'RJ',
        trash: 'TRASH',
        lastFresh: 'LAST FRESH',
        lastFreshFromMarketing: 'LAST FRESH FROM MARKETING',
    },
    sideNav: {
        home: 'Home',
        signOut: 'Sign out',
        cmdc: 'CMDC',
        realTime: 'Real Time',
        statisticReport: 'Statistic Report',
        logistic: 'Logistic',
        history: 'History',
        wallboard: 'Wallboard',
        dailyPubsPriority: 'Daily Pubs Priority',
        campaignOverview: 'Campaign Overview',
        campaignOverviewV2: 'Campaign Overview V2',
        campaignOverviewV3: 'Campaign Overview V3',
        campaignUpdated: 'Campaign Updated',
        publishPerformance: 'Publish Performance',
        publishPerformance2: 'Publish Performance 2',
        networkPerformance: 'Network Performance',
        teamPerformance: 'Team Performance',
        teamCpPerformance: 'Team-CP Performance',
        prodTeamPerf: 'Prod Team perf',
        agentToday: 'Agent Today',
        agentMtd: 'Agent MTD',
        agentChartToday: 'Agent Chart Today',
        agentChartMtd: 'Agent Chart MTD',
        leadDistToday: 'Lead Dist. Today',
        leadDistTodayV2: 'Lead Dist. Today V2',
        leadDistShift: 'Lead Dist. Shift',
        leadDistMtd: 'Lead Dist. MTD',
        leadDistChartToday: 'Lead Dist. Chart Today',
        leadDistChartMtd: 'Lead Dist. Chart MTD',
        teamPerfMtd: 'Team Perf(MTD)',
        teamPerfAll: 'Team Perf(All)',
        teamPerfNew: 'Team Perf(New)',
        teamCpPerfAll: 'Team CP Perf(All)',
        teamCpPerfNew: 'Team CP Perf(New)',
        rescueSummary: 'Rescue Summary',
        rescueCall: 'Rescue Call',
        agentAll: 'Agent(All)',
        dailyStatistic: 'Daily Statistic',
        dailyStatisticNew: 'Daily Statistic(New)',
        fulfillmentStock: 'Fulfillment Stock',
        logDo: 'Log DO',
    },
    common: {
        loading: 'Loading...',
        confirmApi: 'Confirm {{name}}?',
        apiSuccess: '{{name}} success.',
        apiFail: '{{name}} fail.',
        close: 'Close',
        toggleMenu: 'Toggle menu',
        next: 'Next',
        previous: 'Previous',
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        toggleSection: 'Toggle section',
        expandAll: 'Expand all',
        collapseAll: 'Collapse all',
        loadMore: 'Load more',
        todo: 'TODO',
    },
    login: {
        title: 'Login',
        username: 'Username',
        password: 'Password',
        passwordPlaceholder: 'Enter password',
        submit: 'Login',
        loginFailed: 'Login failed.',
        invalidDomain: 'Invalid email domain.',
        needAccount: 'Need an account? Sign up!',
        copyright: 'Copyright © Your Website 2020',
        privacyPolicy: 'Privacy Policy',
        termsConditions: 'Terms & Conditions',
    },
    bdReport: {
        geo: 'Geo',
        affiliate: 'Affiliate',
        all: 'All',
        uploadDatasource: 'Upload datasource',
        metrics: {
            cpa: 'CPA',
            cpl: 'CPL',
            ar: 'AR',
            cv: 'CV',
        },
        columns: {
            no: 'No.',
            affId: 'Aff ID',
            cpaPayout: 'CPA Payout',
            cpaRevenue: 'CPA Revenue',
            cplPayout: 'CPL Payout',
            cplRevenue: 'CPL Revenue',
        },
    },
    hsReport: {
        campaignName: 'Campaign Name',
        batchId: 'Batch ID',
        datePlaceholder: 'yyyy-mm-dd',
        search: 'Search',
        dateFrom: 'Date From',
        dateTo: 'Date To',
        topAgentsFresh: 'Top {{count}} Agents(fresh)',
        topAgentsResell: 'Top {{count}} Agents(resell)',
        columns: {
            campaign: 'Campaign',
            leads: 'Leads',
            new: 'New',
            aov: 'AOV',
            ar: 'AR',
            arQa: 'AR-QA',
            ear: 'E-AR',
            uncall: 'Uncall',
            trash: 'Trash',
            rejected: 'Rejected',
            callback: 'Callback',
            urgent: 'Urgent',
            agent: 'Agent',
            sales: 'Sales',
            approved: 'Approved',
        },
    },
    statisticReport: {
        dateFrom: 'Date From',
        dateTo: 'Date To',
        date: 'Date',
        createdDateFrom: 'Created Date From',
        createdDateTo: 'Created Date To',
        modifiedDateFrom: 'Modified Date From',
        modifiedDateTo: 'Modified Date To',
        search: 'Search',
        export: 'Export',
        keyword: 'Keyword',
        fresh: 'Fresh',
        resell: 'Resell',
        campaign: 'Campaign',
        leadsCountedByCreated: 'The leads in this report will be counted by created date',
        leadsCountedByModified: 'The leads in this report will be counted by modified date',
        leadsCountedByCreatedShort: 'The leads in this report will be counted by Created date',
        leadsCountedByModifiedShort: 'The leads in this report will be counted by Modified date',
        freshCampaign: 'Fresh Campaign',
        resellCampaign: 'Resell Campaign',
        allCampaign: 'All Campaign',
        viewByCreatedDate: 'View by created date',
        viewByModifiedDate: 'View by modified date',
        lastUpdatedAt: 'Last updated at {{time}}',
        firstAttempt: {
            achieved: 'ARCHIEVED',
            failed: 'FAILED',
            error: 'error',
        },
    },
    cmdc: {
        fresh: 'Fresh',
        resell: 'Resell',
        all: 'All',
        search: 'Search',
        cache: 'Cache {{time}}',
        filter: 'Filter',
        apply: 'Apply',
        close: 'Close',
        campaignSummary: 'Campaign Summary',
        view: 'View',
        dateFrom: 'Date From',
        dateTo: 'Date To',
        status: 'Status',
        summaryView: 'Summary View',
        attemptView: 'Attempt View',
        total: 'TOTAL',
        campaign: 'Campaign',
        team: 'Team',
        index: 'Index',
        value: 'Value',
        summary: 'Summary',
        time: 'Time',
        latest: 'Latest',
        avgAttempts: 'Avg.Attempts',
        kpis: 'KPIs',
        longest: 'Longest',
        liveAgents: 'Live agents',
        staffed: 'Staffed',
        latestUpd: 'Latest Upd',
        agentsOf: '# of Agent',
        skillLevel: 'SL {{level}}',
        resellMarker: '(M)',
        agentStatus: {
            assigned: 'Assigned',
            onCall: 'On call',
            wrapUp: 'Wrap up',
            available: 'Available',
            break: 'Break',
            unavailable: 'Unavailable',
            busy: 'Busy',
            logout: 'Logout',
        },
        columns: {
            campaign: 'Campaign',
            leads: 'Leads',
            new: 'New',
            aov: 'AOV',
            ar: 'AR',
            avgAttempt: 'Avg Attempt',
            approved: 'Approved',
            uncall: 'Uncall',
            trash: 'Trash',
            rejected: 'Rejected',
            callback: 'Callback',
            urgent: 'Urgent',
            agent: 'Agent',
            bestMatchRate: 'Best-Match Rate',
            longestWaitTime: 'Longest Wait-time',
            attempts: 'Attempts',
            avg: 'AVG',
            total: 'Total',
        },
    },
    report: {
        download: 'Download',
        noData: 'No Data',
        statusMapping: 'status mapping',
        topAgentsFresh: 'Top {{count}} Agents(fresh)',
        topAgentsResell: 'Top {{count}} Agents(resell)',
        freshCampaignHyphen: 'Fresh-Campaign',
        resellCampaignHyphen: 'Resell-Campaign',
        hierarchyTeam: 'Team',
        hierarchyCampaign: 'Campaign',
        hierarchyAgent: 'Agent',
        priorityOn: 'PRIORITY ON {{date}}',
        source: 'Source',
        ticketCode: 'Ticket Code',
        createDate: 'Create Date',
        payload: 'Payload',
        campaignView: 'Campaign View',
        agentView: 'Agent View',
        leadPlanBySalesCampaign: 'LEAD PLAN BY SALES CAMPAIGN',
        hide: 'Hide',
        noTeam: 'No team',
        marginRules: 'Margin Rules',
        reload: 'Reload',
        marginReloadConfirm: 'Confirm to reload Google margin configuration?',
        range: 'Range',
        chart: {
            delivered: 'Delivered',
            so: 'SO',
            approved: 'Approved',
            leads: 'Leads',
        },
        rescueStatus: {
            pending: '9-pending',
            new: '1-new',
            intransit: '2-intransit',
            delivering: '3-delivering',
            returning: '4-returning',
            unknown: '0-unknown',
        },
        metrics: {
            uncalledShort: 'u',
            rejectedShort: 'r',
            rejectedRj: 'rj',
            callbackShort: 'cb',
            urgentShort: 'ur',
            attemptShort: 'at',
            eAr: 'eAr',
            aov: 'aov',
            arMrp: 'AR_MRP',
            aovMrp: 'AOV_MRP',
            mrp: 'MRP:',
            cplTag: 'CPL',
        },
        alt: {
            diamond: 'Diamond',
        },
        hierarchyGroupAria: 'Hierarchy group',
        campaignOverviewV2: {
            reject: 'Reject',
            closed: 'Closed',
            uncall: 'Uncall',
            callback: 'Callback',
            approved: 'Approved',
            total: 'Total',
            attempt12: '#1-2',
            attempt35: '#3-5',
            attempt68: '#6-8',
            attempt8plus: '#8+',
            abbrevP: 'P',
            abbrevC: 'C',
            abbrevNp: 'NP',
            abbrevN: 'N',
            abbrevV: 'V',
            abbrevD: 'D',
        },
        cards: {
            totalSales: 'Total sales',
            totalSalesCap: 'Total Sales',
            totalOrders: 'Total orders',
            todayOrders: 'Today Orders',
            mtdSales: 'MTD Sales',
            mtdDailySalesF: 'MTD daily sales (F)',
            mtdDailySalesR: 'MTD daily sales (R)',
            mtdDailySales: 'MTD Daily sales',
            totalSalesF: 'Total sales (F)',
            totalSalesR: 'Total sales (R)',
            freshOrders: 'Fresh Orders',
            resellOrders: 'Resell orders',
            todayAovF: "Today's AOV (F)",
            todayAovR: "Today's AOV (R)",
            mtdSalesF: 'MTD sales (F)',
            mtdSalesR: 'MTD sales (R)',
            freshLeads: 'Fresh Leads',
            resellLeads: 'Resell Leads',
            freshToday: 'Fresh Today',
            freshYesterday: 'Fresh Yesterday',
            approve: 'Approve',
            freshCampaigns: 'Fresh Campaigns',
        },
        fulfillment: {
            product: 'Product',
            actualStock: 'Actual stock',
            reservedStock: 'Reserved Stock',
            sellableStock: 'Sellable stock',
        },
        dailyPubs: {
            priority: 'Priority',
            aff: 'Aff',
            offer: 'Offer',
            salesCamp: 'Sales Camp',
            sub: 'Sub',
            leadD1: 'Lead d-1',
            arQa: 'AR QA',
            arQc: 'AR QC',
            tr: 'TR',
            arMrp: 'AR MRP',
            leadMrp: 'Lead MRP',
            plan: 'Plan',
            noteForSales: 'Note for Sales',
        },
        columns: {
            name: 'Name',
            sale: 'Sale',
            hour: 'Hour',
            team: 'Team',
            sl: 'SL',
            fcr: 'FCR',
            ttt: 'TTT',
            pub: 'Pub',
            no: 'No',
            validated: 'Validated',
            leadMrp: 'Lead MRP',
            arQc: 'AR-QC',
            arQaUnderscore: 'AR_QA',
            deliver: 'Deliver',
            dsale: 'D-Sale',
            dr: 'DR',
            daov: 'D-AOV',
            ucAtmp: 'UC_ATMP',
            ucRing: 'UC_Ring',
            att: 'ATT',
            calls: 'Calls',
            odcb: 'ODCB',
            doId: 'Do ID',
            trackingCode: 'Tracking Code',
            ffm: 'FFM',
            lm: 'LM',
            packageName: 'Package Name',
            amount: 'Amount',
            customer: 'Customer',
            phone: 'Phone',
            province: 'Province',
            create: 'Create',
            date: 'Date',
            status: 'Status',
            reason: 'Reason',
            day: 'day',
            latestLead: 'Latest Lead',
            shift: 'Shift',
            agentName: 'Agent Name',
        },
    },
}
